import useSWR from 'swr'

const fetcher = (articleID) =>
  fetch(
    `https://${process.env.NEXT_PUBLIC_SANITY_PROJECT_ID}.api.sanity.io/v${
      process.env.SANITY_API_VERSION
    }/data/query/${
      process.env.NEXT_PUBLIC_SANITY_DATASET
    }?query=*[_id==${encodeURIComponent(articleID)}][0].likes`
  ).then((res) => res.json())

export const useGetLikes = (articleId) => {
  if (!articleId) {
    throw new Error('Article ID is required')
  }

  let id = `"${articleId}"`

  const { data: result } = useSWR(id, fetcher)

  return { currentLikes: result || 0 }
}
